import React from 'react';
import Chip from '@material-ui/core/Chip';
import clsx from 'clsx';
import strings from 'strings';
import { SvgCheck, SvgDelete, SvgWarning } from 'UI/res';
import { nestTernary } from 'UI/utils';

export const EmailChipOrigins = {
  Table: 'table',
  Profile: 'profile'
};
export const EmailChipTypes = {
  Primary: 'primary',
  Secondary: 'secondary'
};

const {
  invalid: invalidCopy,
  valid: validCopy,
  risky: riskyCopy
} = strings.inventoryProfiles.common.emailValidationStatus;

const ChipConfig = {
  valid: {
    icon: <SvgCheck size={12} />,
    className: 'chip-valid-email',
    label: validCopy
  },
  invalid: {
    icon: <SvgDelete size={12} />,
    className: 'chip-invalid-email',
    label: invalidCopy
  },
  risky: {
    icon: <SvgWarning size={12} />,
    className: 'chip-risky-email',
    label: riskyCopy
  }
};

/**
 * @param {Object} props
 * @param {(string|string|string)} props.status
 * @param {(string|string)} props.origin
 * @param {(string|string)} props.emailType
 */
const EmailStatusChip = React.forwardRef(
  (
    {
      status,
      origin = EmailChipOrigins.Table,
      emailType = EmailChipTypes.Primary,
      className,
      ...rest
    },
    ref
  ) => {
    if (!ChipConfig[status]) return null;

    const isProfile = origin === EmailChipOrigins.Profile;
    const isPrimary = emailType === EmailChipTypes.Primary;

    const emailTypePrefix = isProfile
      ? nestTernary(isPrimary, strings.shared.fields.email, strings.shared.fields.otherEmail)
      : '';

    return (
      <Chip
        ref={ref}
        icon={ChipConfig[status].icon}
        variant="outlined"
        size="small"
        label={`${ChipConfig[status].label} ${emailTypePrefix}`}
        {...rest}
        className={clsx(ChipConfig[status].className, className)}
      />
    );
  }
);

export default EmailStatusChip;
